import { gql } from '@apollo/client';

export const GET_VOLUNTEER_TAGS_FOR_FILTER = gql`
  query GetVolunteerTagsForFilter {
    vm {
      volunteerTags {
        volunteerTagId
        name
        colour
        tagGroup
      }
    }
  }
`;
